import React, { useState } from "react";
import { Form, Row, Col, Modal } from "react-bootstrap";
import ApiService from "../../../ApiService";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const SendMessage = props => {
  const [message, setMessage] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSnackClose = () => {
    setSnackOpen(false);
  };
  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const sendMessage = async () => {
    if (!message.trim()) {
      handleSnackOpen("Message cannot be empty", "error");
      return;
    }
    try {
      setLoading(true);
      const r = await ApiService.postPatientMessage({
        kitId: props.kit,
        message: message
      });
      if (r.status === 200) {
        handleSnackOpen("Message Sent", "success");
      }
    } catch (error) {
      console.error(error);
      handleSnackOpen(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal size="lg" show={props.showSendMsgModal} onHide={() => props.closeSendMsgModal} backdrop={"static"}>
      <Modal.Header id="ModalTitle">
        <Modal.Title>Send Message</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6} sm={12}>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="1">
                To:
              </Form.Label>
              <Col sm="10">
                <Form.Control value={props.patient.email} className="form-control" readOnly />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6} sm={12}>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="1">
                CC:
              </Form.Label>
              <Col sm="10">
                <Form.Control value={"care.health@tbd.health"} className="form-control" readOnly />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <Form.Group>
              <Form.Control
                id="popup-textarea"
                as="textarea"
                placeholder="Type your message here..."
                rows={10}
                onChange={e => setMessage(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="modal-footer">
          <button class="btn btn-light" onClick={props.closeSendMsgModal}>
            Cancel
          </button>
          <button id="msg_reply" class="btn btn-primary" onClick={sendMessage} disabled={loading}>
            Send Message <i class="fa fa-paper-plane" aria-hidden="true"></i>
          </button>
        </Row>
      </Modal.Body>
      <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>
    </Modal>
  );
};

export default SendMessage;
